import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'chainmaker-';

export default {
    path: '/chainmaker',
    name: 'chainmaker',
    redirect: {
        name: `${pre}explorer`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'org',
            name: `${pre}org`,
            meta: {
                ...meta,
                title: '组织管理',
                closable: true
            },
            component: () => import('@/pages/alliance/org')
        },
        {
            path: 'explorer',
            name: `${pre}explorer`,
            meta: {
                ...meta,
                title: '区块浏览器',
                closable: true
            },
            component: () => import('@/pages/chain/explorer')
        },
        {
            path: 'management',
            name: `${pre}management`,
            meta: {
                ...meta,
                title: '链管理',
                closable: true
            },
            component: () => import('@/pages/chain/management')
        }
    ]
};
